import { BaseTabFormData } from '@/modules/common/components/templates/feature-details/types/types';

import { ClientIntegration, ClientStatus, PaymentTerms } from './client';

export enum ClientTab {
  Info = 'info',
  Integrations = 'integrations',
}

export enum ClientModalType {
  Delete = 'delete',
  Archive = 'archive',
}

export interface ClientFormData extends BaseTabFormData {
  // Info fields
  name: string;
  avatar?: File;
  status: ClientStatus;
  email: string;
  managerId?: string;
  paymentTerms: PaymentTerms;
  billingAddress?: string;
  shippingAddress?: string;

  // Integration fields - full integration objects with client mappings
  integrations?: ClientIntegration[];
}

export interface ClientIntegrationsFormData {
  integrations?: ClientIntegration[];
}

export * from './client';
export * from './dto/client-short.dto';
export * from './request';
